import React from 'react';
import { Link } from 'react-router-dom';

import { NAVIGATE_PATH as PATH } from '../../../helpers/constants';
import { TOpsSeries } from '../../../requests/opsRecords';
import { Card } from '../ui';

/** The other sessions in this class's series, one link each. */
const SeriesCard: React.FC<{ series: TOpsSeries }> = ({ series }) => (
  <Card
    title={`Series · ${series.count} sessions${
      series.kind === 'mirror' ? ' · from Salesforce' : ''
    }`}
  >
    <div className="flex flex-wrap gap-2 p-4">
      {series.items.map((sib) => (
        <Link
          key={sib.id}
          to={PATH.opsClassEdit.replace(':id', sib.id)}
          className={`rounded-lg border px-3 py-1.5 text-sm transition-colors ${
            sib.current
              ? 'border-blue-primary bg-blue-100 font-semibold text-blue-primary'
              : 'border-white-three text-gray-five hover:border-blue-500'
          }`}
          title={sib.name ?? ''}
        >
          {sib.index}/{series.count}
          <span className="ml-2 text-xs text-gray-bold">
            {sib.start ? sib.start.slice(0, 10) : '—'}
          </span>
        </Link>
      ))}
      <span className="basis-full text-xs text-gray-bold">
        {series.kind === 'mirror'
          ? 'Linked through the Salesforce Opportunity; each session is edited on its own.'
          : 'Each session is its own class with its own roster; register someone on all of them from the roster screen.'}
      </span>
    </div>
  </Card>
);

export default SeriesCard;
